import permissions from '../../../common/constants/permissions';

import './confirm.tpl.html';
import * as _l from 'lodash';

angular
  .module('bulkExport.confirm', ['ngSanitize', 'services.bulkrestore', 'services.error', 'services.permissions'])
  /**
   * Tab items for bulk restore confirm page
   */
  .constant(
    'BulkRestoreConfirmTabs',
    Object.freeze({
      ITEMS: 1,
      OVERWRITE_VALUES: 2,
      SPECIFIC_FIELDS: 3,
      OBJECTS: 4
    })
  )
  /**
   * These keys are used for sorting the records
   */
  .constant(
    'SortKeys',
    Object.freeze({
      NAME: 'sfName'
    })
  )
  /**
   * Controller for the bulkExport.confirm template.
   */
  .controller('ExportConfirmCtrl', [
    '$scope',
    '$filter',
    '$state',
    '$timeout',
    '$rootScope',
    '$q',
    'WizardService',
    'BulkRestoreService',
    'ErrorService',
    'MomentFormats',
    'SortKeys',
    'pagingUtils',
    'progressFactory',
    'BulkRestoreConfirmTabs',
    'BULK_RESTORE_EVENTS',
    'confirmModalUtils',
    'permissionService',
    'SOBJECT_STATE',
    'configService',
    function (
      $scope,
      $filter,
      $state,
      $timeout,
      $rootScope,
      $q,
      WizardService,
      BulkRestoreService,
      ErrorService,
      MomentFormats,
      SortKeys,
      pagingUtils,
      progressFactory,
      BulkRestoreConfirmTabs,
      BULK_RESTORE_EVENTS,
      confirmModalUtils,
      permissionService,
      SOBJECT_STATE,
      configService
    ) {
      if (!$state.params.bulkRestoreData) {
        throw new Error('bulkRestoreData is required');
      }

      var i18n = $filter('i18n');
      var pluralize = $filter('pluralize');
      var bulkRestoreData = $state.params.bulkRestoreData;

      var model;

      // Published functions
      $scope.canIncludeChildren = canIncludeChildren;
      $scope.getPageTitle = getPageTitle;
      $scope.getConfirmSummary = getConfirmSummary;
      $scope.getDateTime = getDateTime;
      $scope.getHeaderClass = getHeaderClass;
      $scope.getIncludeChildrenSummary = getIncludeChildrenSummary;
      $scope.getObjectTypeString = getObjectTypeString;
      $scope.sortRecords = sortRecords;
      $scope.getStatus = getStatus;
      $scope.handleError = handleError;
      $scope.handleResponse = handleResponse;
      $scope.isTabSelected = isTabSelected;
      $scope.queueExport = queueExport;
      $scope.showTab = showTab;
      $scope.updateRecords = updateRecords;

      $scope.bulkRestoreData = bulkRestoreData;
      $scope.BulkRestoreConfirmTabs = BulkRestoreConfirmTabs;
      $scope.SortKeys = SortKeys;

      configService.getConfig().then((config) => {
        $scope.searchSortAvailable = config.searchSortAvailable;
      });
      bulkRestoreData.setSortBy(null);
      bulkRestoreData.setAscending(null);

      // To each entry add a summary string showing the configured field names
      _.each(bulkRestoreData.getSpecificFieldEntries(), function (sfEntry) {
        sfEntry.fieldNamesStr = sfEntry.objectFields.join(', ');
      });

      const pageSize = 20;

      const csvResultPagingParams = pagingUtils.pagingInfo.bulkRestoreSelectedRecords;
      csvResultPagingParams.totalItems = bulkRestoreData.getSelectedObjectRecordCount();
      csvResultPagingParams.totalPages = Math.ceil(
        csvResultPagingParams.totalItems / csvResultPagingParams.itemsPerPage
      );
      csvResultPagingParams.currentPage = 1;
      bulkRestoreData.setSearchPageToken(null);
      bulkRestoreData.setSearchPageBatchId(null);
      bulkRestoreData.setSearchToken(null);

      const selectedObjectTypes = bulkRestoreData.getSelectedObjectTypes();

      // Store data in a model object rather than the scope itself for easier watching
      $scope.model = model = {
        isCsvVerifiedRestore: bulkRestoreData.isRestoreFromCsv(),
        currentTab: selectedObjectTypes ? BulkRestoreConfirmTabs.OBJECTS : BulkRestoreConfirmTabs.ITEMS,
        selectedRecords: [],
        selectedObjectTypes,
        lastPage: true
      };

      initWizardPage();

      // Get the records to display
      $scope.updateRecords();

      /**
       * Sets up this page for use with the wizard service.
       */
      function initWizardPage() {
        // Register our page with the wizard service
        var page = WizardService.getCurrentPage();
        page.setHeaderText(i18n('CONFIRM_CHANGES'));
        page.setStateParams($state.params);
        page.setValid(true); // There are no settings on this page so its always valid
        // For the purposes of confirming cancellation of the wizard we'll consider the wizard touched if we get this
        // far.
        page.setTouched(true);

        // Add a custom button to the wizard to handle Export
        var exportButton = page.addCustomButton();
        exportButton.setTextKey('EXPORT');
        exportButton.setTooltipKey('EXPORT');
        exportButton.setEnabled(function () {
          return !progressFactory.bulkRestorePreviewInProgress;
        });

        exportButton.setVisible(false);

        permissionService.hasPermission(permissions.EXPORT).then((hasPermission) => {
          if (hasPermission) {
            exportButton.setVisible(true);
            $timeout(function () {
              $scope.$apply();
            });
          }
        });

        exportButton.setClick(function () {
          return confirmModalUtils
            .openConfirmModal({
              titleTextKey: 'CONTINUE',
              confirmTextKey: 'OBJECT_EXPORT_CONFIRMATION'
            })
            .then((isConfirmed) => {
              if (isConfirmed) {
                return queueExport();
              }

              return false;
            });
        });
      }

      /**
       * Function to determine if item is selected.
       * @param {Number} tab - The tab to check if its the current one.
       * @returns {Boolean} - Flag if the item is selected or not.
       */
      function isTabSelected(tab) {
        return model.currentTab === tab;
      }

      /**
       * Function to show the correct content for the selected tab.
       * @param {Number} tab - The tab to set to the current tab.
       */
      function showTab(tab) {
        model.currentTab = tab;
      }

      /**
       * Displays the next page of selected records.
       *
       * @returns Promise - a promise that resolves when the update completes.
       */
      function updateRecords() {
        if (bulkRestoreData.checkObjectTypeSelectedCount(1)) {
          return;
        }
        // See if we can use the selected records in the bulk restore data.
        if (bulkRestoreData.canGetSelectedObjectRecords()) {
          const pageToken = bulkRestoreData.getSearchPageToken();
          const sortBy = bulkRestoreData.getSortBy();
          const ascending = bulkRestoreData.getAscending();
          let records = _l.orderBy(
            bulkRestoreData.getSelectedObjectRecords(),
            sortBy ? sortBy : 'id',
            ascending ? 'asc' : 'desc'
          );
          if (pageToken) {
            records = records.filter((record) => record.id > pageToken);
          }
          records = records.slice(0, pageSize);

          model.lastPage = records.length < pageSize;

          model.selectedRecords.push(...records);
          bulkRestoreData.setSearchPageToken(_l.last(model.selectedRecords).id);
          return Promise.resolve();
        }

        $rootScope.showLoadingMask = true;

        let getRecordsPromise;
        if (bulkRestoreData.isRestoreFromCsv()) {
          getRecordsPromise = BulkRestoreService.getCsvVerificationResults(bulkRestoreData, csvResultPagingParams);
        } else {
          getRecordsPromise = BulkRestoreService.searchRecordsPage(bulkRestoreData, pageSize);
        }

        return getRecordsPromise
          .then(function (results) {
            const selectedRecords = bulkRestoreData.checkAndMarkRecordsAreIncludingChildren(results.records);
            model.selectedRecords.push(...selectedRecords);
            if (bulkRestoreData.isRestoreFromCsv()) {
              csvResultPagingParams.totalItems = results.numberOfRecords;
              csvResultPagingParams.totalPages = Math.ceil(
                csvResultPagingParams.totalItems / csvResultPagingParams.itemsPerPage
              );
              model.lastPage = selectedRecords.length < csvResultPagingParams.pageSize;
              csvResultPagingParams.page++;
            } else {
              model.lastPage = selectedRecords.length < pageSize;
              if (results.searchToken) {
                bulkRestoreData.setSearchToken(results.searchToken);
              }
              if (results.records.length > 0) {
                bulkRestoreData.setSearchPageToken(results.pageToken);
                bulkRestoreData.setSearchPageBatchId(results.pageBatchId);
              }
            }
          })
          .catch(function (err) {
            ErrorService.report(err, i18n('DELETED_ITEMS_RECORDS_FAILED'));
          })
          .finally(function () {
            $rootScope.showLoadingMask = false;
          });
      }

      /**
       * Utility to get the confirm page title.
       *
       * @return {string} - The title of the confirm page.
       */
      function getPageTitle() {
        let title;

        if (!selectedObjectTypes) {
          let objectType = getObjectTypeString();

          const recordsToRestoreCount = bulkRestoreData.getSelectedObjectRecordsCountInfo();

          if (recordsToRestoreCount.count === 1) {
            title = i18n('CONFIRM_RESTORE_RECORD', objectType);
          } else {
            title = i18n('CONFIRM_RESTORE_RECORDS', [recordsToRestoreCount.text, objectType]);
          }
        } else {
          const selectedMultipleObjects = bulkRestoreData.checkObjectTypeSelectedCount(2);
          title = selectedMultipleObjects
            ? i18n('CONFIRM_RESTORE_OBJECTS', [
                selectedObjectTypes.selectedList.length,
                selectedObjectTypes.selectedList.join(', ')
              ])
            : i18n('CONFIRM_RESTORE_OBJECT', [selectedObjectTypes.selectedList[0]]);
        }

        return title.trim();
      }

      /**
       * Utility to get the confirm page summary.
       *
       * @return {string} - The summary of the bulk restore wizard.
       */
      function getConfirmSummary() {
        const selectedObjectRecords = bulkRestoreData.getSelectedObjectRecords(true);
        const length = Array.isArray(selectedObjectRecords) ? selectedObjectRecords.length : 0;

        let recordsStr = pluralize(length, 'RECORD', 'RECORDS');
        let summary;

        if (!selectedObjectTypes) {
          const recordsToRestoreCount = bulkRestoreData.getSelectedObjectRecordsCountInfo();
          summary = i18n('EXPORT_RECORDS', [
            recordsToRestoreCount.text,
            getObjectTypeString(),
            recordsStr.toLowerCase()
          ]);
        } else {
          summary = i18n('EXPORT_RECORDS', [getPageTitle(), ' ', ' ']);
        }

        return summary;
      }

      /**
       * Returns a string describing the selected object type(s).
       *
       * @returns {string} a comma-separated list of the selected object types.
       */
      function getObjectTypeString() {
        if (bulkRestoreData.isRestoreFromCsv()) {
          return bulkRestoreData.getSelectedObjectRecordTypes().join(',');
        } else {
          return bulkRestoreData.getSearchObjectType();
        }
      }

      /**
       * Returns a string describing the inclusion of children of deleted records.
       *
       * @returns {string} - The summary of the include children action.
       */
      function getIncludeChildrenSummary() {
        var settingTypeStr = i18n('INCLUDE_CHILDREN').toLowerCase().trim();
        var notStr = bulkRestoreData.isIncludingAllChildren() ? '' : i18n('NOT').toLowerCase();
        return i18n('RECORDS_SETTING_SUMMARY', [notStr, settingTypeStr]);
      }

      /**
       * Returned the formatted dateTime string from a record object.
       *
       * @param {string} recordDate - A string date.
       * @returns {string} - A formatted date string.
       */
      function getDateTime(recordDate) {
        return moment(recordDate).format(MomentFormats.BATCH);
      }

      /**
       * Returned the status for the record object.
       *
       * @param {object} record - the record object.
       * @returns {string} - the status.
       */
      function getStatus(record) {
        if (bulkRestoreData.isManualObjectBrowse()) {
          return i18n('IN_BACKUP');
        }
        let searchObjectStates = bulkRestoreData.getSearchObjectStates();
        if (record && record.isDeleted) {
          return i18n('DELETED');
        }
        if (searchObjectStates.indexOf(SOBJECT_STATE.UPDATED) >= 0) {
          return i18n('UPDATED');
        }
        if (searchObjectStates.indexOf(SOBJECT_STATE.NEW) >= 0) {
          return i18n('NEW_OR_UPDATED');
        }
        if (searchObjectStates.indexOf(SOBJECT_STATE.UNCHANGED) >= 0) {
          return i18n('UNCHANGED');
        }
        if (searchObjectStates.indexOf(SOBJECT_STATE.DELETED) >= 0) {
          return i18n('DELETED');
        }
        return i18n('UPDATED');
      }

      /**
       * Sorts the object records by the specified key.
       *
       * @param {string} sortKey - The sort key.
       */
      function sortRecords(sortKey) {
        if (!$scope.searchSortAvailable) {
          return;
        }
        if (bulkRestoreData.getSortBy() !== sortKey) {
          // Start with ascending when we switch to a new column
          bulkRestoreData.setSortBy(sortKey);
          bulkRestoreData.setAscending(true);
          csvResultPagingParams.sort = sortKey;
          csvResultPagingParams.ascending = true;
        } else {
          // Toggle the direction when we stay on the same column
          bulkRestoreData.setAscending(!bulkRestoreData.getAscending());
          csvResultPagingParams.ascending = !csvResultPagingParams.ascending;
        }

        bulkRestoreData.setSearchPageToken(null);
        bulkRestoreData.setSearchPageBatchId(null);
        bulkRestoreData.setSearchToken(null);
        model.selectedRecords = [];

        return $scope.updateRecords();
      }

      /**
       * Returns the class to be used to style a header in the record list.
       *
       * @param {string} sortKey - The sort key used to identify the header.
       * @returns {string} The class to use.
       */
      function getHeaderClass(sortKey) {
        let headerClass = '';
        if (bulkRestoreData.getSortBy() === sortKey && $scope.searchSortAvailable) {
          if (bulkRestoreData.getAscending()) {
            headerClass = 'sbsf-log-header-asc sca-icon-down-black';
          } else {
            headerClass = 'sbsf-log-header-desc sca-icon-down-black';
          }
        }
        return headerClass;
      }

      /**
       * Queues an export.
       *
       * @returns {Promise} a promise that is resolved with one of the following:
       *   1) true if the wizard can be dismissed
       *   2) false if the wizard should remain
       *   3) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function queueExport() {
        $rootScope.showLoadingMask = true;

        return BulkRestoreService.submitExport(bulkRestoreData)
          .then(function (res) {
            return $scope.handleResponse(res);
          })
          .catch(function (err) {
            return $scope.handleError(err);
          })
          .finally(function () {
            $rootScope.showLoadingMask = false;
          });
      }

      /**
       * Handles a response from submitting the operation.
       *
       * @param {object} res - the response object.
       * @returns {boolean|object} one of the following:
       *   1) true if the wizard can be dismissed
       *   2) false if the wizard should remain
       *   3) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function handleResponse(res) {
        // Status of 1 indicates a failure
        if (res.status === 1) {
          return $scope.handleError(res.message);
        }

        progressFactory.bulkRestorePreviewInProgress = true;

        return true; // We're done with the wizard
      }

      /**
       * Handles an error from restoreOrExport.
       *
       * @param {object|string} err - the error object or message.
       * @returns {boolean|object} one of the following:
       *   1) false if the wizard should remain
       *   2) an object containing the parameters to pass to the wizard cancel function to display an error message.
       */
      function handleError(err) {
        var msg;
        if (typeof err === 'string') {
          msg = err;
        } else if (err && err.message) {
          msg = err.message;
        } else if (err && err.data && err.data.message) {
          msg = err.data.message;
        }

        // If the error message contains access_token_owner_id, we know that access_token_owner_id on auth_info does
        // not match access_token_owner_id that created the auth row.
        // Handle differently by showing modal.
        if (msg && msg.indexOf('access_token_owner_id') > -1) {
          // Return parameters to indicate we need an error popup
          return {
            showConfirm: true,
            confirmTextKey: 'ACCESS_TOKEN_OWNER_ID_ERROR',
            confirmButtonTextKey: 'GO_TO_DASHBOARD',
            extraHeight: true
          };
        }

        // We don't recognize the message
        var fallbackMsg = i18n('BULK_RESTORE_PREVIEW_SUBMIT_FAILED');
        ErrorService.report(msg, fallbackMsg);
        return false; // Didn't succeed, but we don't need the wizard to display the message.
      }

      /**
       * Determines whether the option to include children in the restore should be shown
       *
       * @returns {boolean} true if the option should be shown.
       */
      function canIncludeChildren() {
        // Always show this for CSV uploads
        if (bulkRestoreData.isRestoreFromCsv()) {
          return true;
        }

        // We only show the option if the selected records contain any deleted records
        return bulkRestoreData.hasSelectedDeletedObjects();
      }
    }
  ]);
